// import Vue from 'vue';
import Locale from '@/helper/locale/Locale.js';
import Util from '@/helper/Utility.js';

//#region Purchase
export function PurchaseListConfigModel(strConfigList, intSkip, intTop) {
    this.isSeeMoreEnable = true;
    this.strConfigList = strConfigList || 'purchase';
    this.intSkip = intSkip || 0;
    this.defaultTopAmount = intTop || 25;
    this.strLocale = Locale.getLocaleCode();
    this.startDate = null;
    this.endDate = null;
    this.type = 'list';

    this.updateListConfig = function (purchaseListConfig) {
        this.isSeeMoreEnable = purchaseListConfig.isSeeMoreEnable
        this.strConfigList = purchaseListConfig.strConfigList;
        this.intSkip = purchaseListConfig.intSkip;
        this.defaultTopAmount = purchaseListConfig.defaultTopAmount;
        this.strLocale = purchaseListConfig.strLocale;
    };

    this.resetListConfig = function () {
        this.isSeeMoreEnable = true;
        this.intSkip = 0;
        this.strLocale = Locale.getLocaleCode();
    };

    this.getParams = function() {
        var params = {
            byConfig: true,
            config: this.strConfigList,
            $top: this.defaultTopAmount,
            $skip: this.intSkip,
            device_locale: this.strLocale,
            startdate: this.startDate,
            enddate: this.endDate,
            type: this.type
        };

        params = Util.cleanObjectNullKey(params);
        return params;
    };

    this.increstSkip = function () {
        this.intSkip += this.defaultTopAmount;
    };

    /**
     * @param {boolean} enable
     */
    this.setSeeMoreEnable = function (enable) {
        this.isSeeMoreEnable = enable;
    };
}
export function PurchaseListConfigBuilder() {
    this.historyConfig = new PurchaseListConfigModel();

    this.create = () => {
        return this.historyConfig;
    };

    this.setIsSeeMoreEnable = (isSeeMoreEnable) => {
        this.historyConfig.isSeeMoreEnable = isSeeMoreEnable;
        return this;
    };

    this.setConfigList = (strConfigList) => {
        this.historyConfig.strConfigList = strConfigList;
        return this;
    };

    this.setSkip = (intSkip) => {
        this.historyConfig.intSkip = intSkip;
        return this;
    };

    this.setTop = (intTop) => {
        this.historyConfig.defaultTopAmount = intTop;
        return this;
    };

    /**
     * @param {string} startDate yyyy-mm-ddTHH:MM:SS, example: 2020-01-01T00:00:00
     */
    this.setStartDate = (startDate) => {
        this.historyConfig.startDate = startDate;
        return this;
    };

    /**
     * @param {string} endDate yyyy-mm-ddTHH:MM:SS, example: 2020-01-31T23:59:59
     */
    this.setEndDate = (endDate) => {
        this.historyConfig.endDate = endDate;
        return this;
    };
}

//#region custom for JCB
PurchaseListConfigBuilder.prototype.setType = function(t){
    this.historyConfig.type = t
    return this
}
PurchaseListConfigBuilder.prototype.setMode = function(m){
    this.historyConfig.mode = m
    return this
}
//#endregion

export function PurchaseFilterConfigModel(strSearch, strCatId, strSponsorId, strCenter) {
    this.strSearch = strSearch || '';
    this.strCatId = strCatId || '';
    this.strSponsorId = strSponsorId || '';
    this.strCenter = strCenter || '';

    this.updateFilterListConfig = function (purchaseFilterConfig) {
        this.strSearch = purchaseFilterConfig.strSearch;
        this.strCatId = purchaseFilterConfig.strCatId;
        this.strSponsorId = purchaseFilterConfig.strSponsorId;
        this.strCenter = purchaseFilterConfig.strCenter;
    };

    this.getParams = function() {
        var params = {
            q: this.strSearch,
            cat: this.strCatId,
            sponsorId: this.strSponsorId,
            center: this.strCenter,
        }

        params = Util.cleanObjectNullKey(params);
        return params;
    };
}
export function PurchaseFilterConfigBuilder() {
    this.purchaseFilterConfig = new PurchaseFilterConfigModel();

    this.create = () => {
        return this.purchaseFilterConfig;
    };

    this.setSearch = (strSearch) => {
        this.purchaseFilterConfig.strSearch = strSearch;
        return this;
    };

    this.setCatId = (strCatId) => {
        this.purchaseFilterConfig.strCatId = strCatId;
        return this;
    };

    this.setSponsorId = (strSponsorId) => {
        this.purchaseFilterConfig.strSponsorId = strSponsorId;
        return this;
    };

    this.strCenter = (strCenter) => {
        this.purchaseFilterConfig.strCenter = strCenter;
        return this;
    };
}
//#endregion Purchase
//#region earn
export function PointListConfigModel(isSeeMoreEnable, strType, strDate, intTop, strLastRowKey, isOtherPoint) {
    this.isSeeMoreEnable = true;
    this.strType = strType || 'all';
    this.strDate = strDate || '';
    this.defaultTopAmount = intTop || 25;
    this.strLastRowKey = strLastRowKey || '';
    this.isOtherPoint = isOtherPoint || false;

    this.updateListConfig = function (pointListConfig) {
        this.isSeeMoreEnable = pointListConfig.isSeeMoreEnable;
        this.strType = pointListConfig.strType;
        this.strDate = pointListConfig.strDate;
        this.defaultTopAmount = pointListConfig.intTop;
        this.strLastRowKey = pointListConfig.strLastRowKey;
        this.isOtherPoint = pointListConfig.isOtherPoint;
    };

    this.resetListConfig = function () {
        this.isSeeMoreEnable = true;
        this.strLastRowKey = '';
    };
}
export function PointListConfigBuilder() {
    this.pointListConfig = new PointListConfigModel();

    this.create = () => {
        return this.pointListConfig;
    };

    this.setSeeMore = (isSeeMoreEnable) => {
        this.pointListConfig.isSeeMoreEnable = isSeeMoreEnable;
        return this;
    };

    this.setType = (strType) => {
        this.pointListConfig.strType = strType;
        return this;
    };

    this.setDate = (strDate) => {
        this.pointListConfig.strDate = strDate;
        return this;
    };

    this.setTop = (intTop) => {
        this.pointListConfig.defaultTopAmount = intTop;
        return this;
    };

    this.setLastRowKey = (strLastRowKey) => {
        this.pointListConfig.strLastRowKey = strLastRowKey;
        return this;
    };

    this.setOtherPoint = (isOtherPoint) => {
        this.pointListConfig.isOtherPoint = isOtherPoint;
        return this;
    };
}
//#endregion earn
